export default __webpack_public_path__ + "static/media/pcActive.f8a9a17e.png";